<template>
  <div class="callback">Callback</div>
</template>

<script>
export default {
  name: 'AuthCallback',
  mounted() {
    this.$auth.handleAuthentication().then((data) => {
      this.$router.push({ name: 'Home' })
    })
  }
}
</script>
